<footer class="flex w-full justify-center text-neutral-500 my-5">
    <p>{{ 'shared.all_rights_reserved' | transloco }}</p>
</footer>